import React from "react";
import "./SurfPackages.css";
import { Button } from "../../Components/Button/Button";

const packages = [
  { price: "$1,300", name: "PRIVADA", lessons: null },
  { price: "$1,000", name: "GRUPAL", lessons: null },
];

export const SurfPackages = () => {
  return (
    <section className="surf-packages">
      <h2 className="surf-packages__title">Clases de Surf</h2>
      <div className="surf-packages__container">
        {packages.map((pkg, index) => (
          <div key={index} className="surf-package__card">
            <p className="surf-package__price">{pkg.price}</p>
            <h3 className="surf-package__name">{pkg.name}</h3>
            {pkg.lessons && (
              <p className="surf-package__lessons">{pkg.lessons}</p>
            )}
            <Button text="Reservar" type="secondary" size="small" />
          </div>
        ))}
      </div>
    </section>
  );
};
